import { useContext, useEffect } from "react";
import { useState } from "react";
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import Swal from 'sweetalert2';
import { getRankings, getRegNums } from "../services/ArchiveService";
import { ArchiveCard } from "../components/ArchiveCard";
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { AuthContext } from "../../contexts/AuthContext";
import * as fileService from '../services/fileService';
import { RegisterContext } from "../../contexts/RegisterContext";
import { ArchiveSearchApplications } from "../components/ArchiveSearchApplications";
import { MobileContext } from "../../contexts/MobileContext";

export function AdminArchive() {
    const [loading, setLoading] = useState(false);
    const [rankings, setRankings] = useState([]);
    const { user } = useContext(AuthContext);
    const [searchRanking, setSearchRanking] = useState({
        rankingId: '',
        rankingDate: '',
        school: user.role == 'Director' ? user.school : { id: 0, shortName: 'Всички' }
    });
    const { schools } = useContext(RegisterContext);
    const [schoolOptions, setSchoolOptions] = useState([{ id: 0, shortName: 'Всички' }, ...schools])
    const [regNums, setRegNums] = useState([]);
    const { isOnMobile } = useContext(MobileContext);

    useEffect(() => {
        setLoading(true);
        getRankings()
            .then((data) => {
                setRankings(data);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                Swal.fire({
                    title: 'Внимание!',
                    text: err.message,
                    icon: 'error',
                    confirmButtonText: 'ОК'
                })
            })

        document.title = `Архив`;

    }, [])

    useEffect(() => {
        if (searchRanking.rankingId) {
            setLoading(true);
            getRegNums(searchRanking.rankingId, searchRanking.school.id)
                .then((data) => {
                    setRegNums(data)
                    setLoading(false)
                })
                .catch((err) => {
                    setLoading(false);
                    Swal.fire({
                        title: 'Внимание!',
                        text: err.message,
                        icon: 'error',
                        confirmButtonText: 'ОК'
                    })
                })

        }
    }, [searchRanking])

    const handleChange = (e) => {

        let fieldName = e.target.name;
        let fieldValue = e.target.value;

        if (fieldName == 'ranking') {
            setSearchRanking(state => ({
                ...state,
                rankingId: fieldValue.rankingId,
                rankingDate: fieldValue.rankingDate
            }));
        } else {
            setSearchRanking(state => ({
                ...state,
                school: fieldValue,
            }));
        }
    }

    const getRankingPDF = async (e, type) => {
        e.preventDefault();

        try {
            setLoading(true);
            let downloadUrl = '';

            if (type == 'ranking') {
                downloadUrl = await fileService.getArchiveRankingChildrenPDF(searchRanking.rankingId, searchRanking.school.id == 0 ? null : searchRanking.school.id)
            } else if (type == 'confirmed') {
                downloadUrl = await fileService.getArchiveConfirmedChildrenPDF(searchRanking.rankingId, searchRanking.school.id == 0 ? null : searchRanking.school.id)
            } else if (type == 'cancelled') {
                downloadUrl = await fileService.getArchiveCancelledChildrenPDF(searchRanking.rankingId, searchRanking.school.id == 0 ? null : searchRanking.school.id)
            } else if (type == 'exired') {
                downloadUrl = await fileService.getArchiveExiredChildrenPDF(searchRanking.rankingId, searchRanking.school.id == 0 ? null : searchRanking.school.id)
            }

            if (downloadUrl) {
                if (isOnMobile) {
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.download = 'document.pdf';
                    link.click();
                } else {
                    const newTab = window.open(downloadUrl, '_blank');
                    if (!newTab || newTab.closed || typeof newTab.closed === 'undefined') {
                        console.error('Error: The browser blocked opening a new tab.');
                        Swal.fire({
                            title: 'Браузърът блокира отварянето на PDF файла.',
                            text: 'Проверете настройките на браузъра си за поверителност и сигурност(Privacy & Security.),за Chrome: Изскач. прозорци и пренасочвания(Pop-ups and Redirects), за Mozilla: Разрешения(Permissions)',
                            icon: 'error',
                            confirmButtonText: 'ОК'
                        })
                    }
                }
            }

            setLoading(false);
        } catch (error) {
            console.error('Error fetching PDF:', error);
            Swal.fire({
                title: 'Внимание!',
                text: error.message,
                icon: 'error',
                confirmButtonText: 'ОК'
            })
        }
    }

    const selectedSchoolTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <div>{option.shortName}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const streetSchoolTemplate = (option) => {
        return (
            <div className="flex align-items-center">
                <div>{option.shortName}</div>
            </div>
        );
    };

    const selectedRankingTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <div>{option.rankingDate}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const RankingTemplate = (option) => {
        return (
            <div className="flex align-items-center">
                <div>{option.rankingDate}</div>
            </div>
        );
    };



    return (
        <main id="main" className="main">
            <CircleSpinnerOverlay loading={loading} color="#1c79c0" outerBorderOpacity={0.3} outerBorderWidth={6} />
            <div className="pagetitle">
                <h1 className="use-font">Архив</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/schadm">Начало</a></li>
                        <li className="breadcrumb-item active">Архив</li>
                    </ol>
                </nav>
            </div>

            <section className="section dashboard">

                <div className="row ">
                    {rankings.length > 0
                        ? <div className="col-lg-12 ">
                            <div className="row card d-flex flex-row flex-wrap w-100 gap-2 justify-content-strat align-items-center p-4 p-3-mob">
                                <div className="d-flex flex-row flex-wrap w-17 w-40-l gap-2 justify-content-strat align-items-center w-100-mob">
                                    <label className="w-100"><b>Класиране</b></label>
                                    <Dropdown
                                        name="ranking"
                                        value={{ rankingId: searchRanking.rankingId, rankingDate: searchRanking.rankingDate }}
                                        className="w-100 prime-dropdown-heigth border-dropdown-arch"
                                        options={rankings}
                                        optionLabel="name"
                                        filter
                                        placeholder='Изберете класиране'
                                        valueTemplate={selectedRankingTemplate}
                                        itemTemplate={RankingTemplate}
                                        onChange={handleChange}
                                    />
                                </div>

                                {user.role != 'Director' &&
                                    <div className="d-flex flex-row flex-wrap w-25 w-40-l gap-2 justify-content-strat align-items-center  w-100-mob">
                                        <label className="w-100"><b>Училище</b></label>
                                        <Dropdown
                                            name="school"
                                            value={searchRanking.school}
                                            className="w-100 prime-dropdown-heigth border-dropdown-arch"
                                            options={schoolOptions}
                                            optionLabel="name"
                                            filter
                                            placeholder='Изберете училище'
                                            valueTemplate={selectedSchoolTemplate}
                                            itemTemplate={streetSchoolTemplate}
                                            onChange={handleChange}
                                        />
                                    </div>
                                }
                                {searchRanking.rankingId && searchRanking.school &&
                                    <div className={`d-flex gap-2 flex-wrap ${user.role == 'Director' ? 'w-80' : 'w-54'}  w-100-mob w-100-l`}>
                                        <Button label="Класирани деца" icon="pi pi-file-pdf" className={`btn-arch-rank  fade ${user.role == 'Director' ? 'w-18' : 'w-25'}  w-100-mob py-2-mob`}onClick={(e) => getRankingPDF(e, 'ranking')} />
                                        <Button label="Записани деца" icon="pi pi-file-pdf" raised onClick={(e) => getRankingPDF(e, 'confirmed')} className={`btn-arch-conf  fade ${user.role == 'Director' ? 'w-18' : 'w-25'} w-100-mob py-2-mob`} />
                                        <Button label="Отказан прием" icon="pi pi-file-pdf" severity="success" onClick={(e) => getRankingPDF(e, 'cancelled')} raised className={`btn-arch-cancel  fade ${user.role == 'Director' ? 'w-18' : 'w-25'} w-100-mob py-2-mob`} />
                                        <Button label="Непотвърден в срок" icon="pi pi-file-pdf" severity="success" onClick={(e) => getRankingPDF(e, 'exired')} raised className={`btn-arch-cancel  fade ${user.role == 'Director' ? 'w-18' : 'w-25'} w-100-mob py-2-mob`} />
                                    </div>
                                }
                            </div>
                            <div className="row">
                                {regNums.length > 0 && <ArchiveSearchApplications regNums={regNums} schoolId={searchRanking.school.id} />}
                            </div>
                        </div>
                        : <p className="text-center">В момента няма изминали класирания</p>}
                </div>

            </section>

        </main>
    )
}

export default AdminArchive;